export interface ContextInput { viewportWidth: number; referrer: string; search: string }
export interface AnalyticsContext { device: 'mobile' | 'desktop'; source: string | null }

const MOBILE_MAX = 768;

export function resolveContext(input: ContextInput): AnalyticsContext {
  const device: 'mobile' | 'desktop' = input.viewportWidth <= MOBILE_MAX ? 'mobile' : 'desktop';
  const params = new URLSearchParams(input.search);
  const utm = params.get('utm_source');
  let source: string | null = utm && utm.trim() ? utm.trim() : null;
  if (!source && input.referrer) {
    try { source = new URL(input.referrer).host || null; } catch { source = null; }
  }
  return { device, source };
}
